import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import Select from "react-select";
import { userActions } from "../../_actions";
import { AdminMessage, Routes } from "../../_components";
import { userConstants } from "../../_constants";
import "../../assets/css/requestEdu.css";

Modal.setAppElement("#root");

class RequestEdu_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobGroupValue: null,
      jobGroupOptions: [],
      dutyLocationValue: null,
      dutyLocationOptions: [],
      titles: [],
      finalPostModal: false,
      activeIds: [],
      post: {},
      userComment: "",
    };
    this.globalStorage = this.props.globalStorage;
    this.config = {
      headers: {
        Authorization: this.props.globalStorage.token,
      },
    };
  }

  componentDidMount = () => {
    this.getWardLists();
    this.getJobGroups();
    this.getRequestedCourses();
    document.querySelector(".wave").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  goBack = () => {
    this.props.history.goBack();
  };

  getWardLists = () => {
    this.props
      .dispatch(
        userActions.API("get", `v1/user/hospital/ward_lists`, null, true, false)
      )
      .then((res) => {
        const filteredLocations = res.data.filter(
          (location) => location.name !== "بخش ناشناس"
        );
        this.setState({
          dutyLocationOptions: filteredLocations.map(({ _id, name }) => ({
            id: _id,
            name,
          })),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getJobGroups = () => {
    const tempJobGroup = localStorage.getItem("temp_job_group");
    const isHaveTempPost = !["", undefined, null].includes(tempJobGroup);
    const doesHavePost = JSON.parse(
      localStorage.getItem("globalStorage")
    ).value.hasOwnProperty("post");

    this.props
      .dispatch(
        userActions.API("get", `v1/hospital/job_groups`, null, true, false)
      )
      .then((res) => {
        this.setState({
          jobGroupOptions: res.data.map(({ id, name }) => ({
            id,
            name,
          })),
        });
        if (isHaveTempPost) {
          if (res.data.some((group) => group.name === tempJobGroup)) {
            this.setState({
              jobGroupValue: this.state.jobGroupOptions.find(
                (obj) => obj.name === tempJobGroup
              ),
            });
            this.getTitles();
          }
        } else {
          if (doesHavePost) {
            const postArr = JSON.parse(localStorage.getItem("globalStorage"))
              .value.post;
            if (postArr.length !== 0) {
              const post = postArr[0].job_group;

              if (res.data.some((group) => group.name === post)) {
                this.setState({
                  jobGroupValue: this.state.jobGroupOptions.find(
                    (obj) => obj.name === post
                  ),
                });
                this.getTitles();
              }
            }
          }
        }
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getTitles = () => {
    if (!this.state.jobGroupValue) return null;

    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/course/titles?job_group=${this.state.jobGroupValue.id}`,
          null,
          true,
          false
        )
      )
      .then((res) => {
        this.setState({
          titles: res.data.map(({ id, title, course_type }) => ({
            id,
            title,
            course_type,
          })),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getCourses = () => {
    this.props
      .dispatch(userActions.API("get", `v1/user/hospital/courses`))
      .then((res) => {
        // const randomCurrUserReq = res.data.find((req) => req.user_id);
        this.setState({
          activeIds: res.data.map((course) => course.course_id),
        });
        // this.setState({
        //   isRequestEduDone:
        //     randomCurrUserReq === undefined
        //       ? false
        //       : randomCurrUserReq.status !== "draft",
        // });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getRequestedCourses = () => {
    const { activeIds } = this.state;

    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/requested_courses`,
          null,
          true,
          false
        )
      )
      .then((res) => {
        res.data.length &&
          this.setState({
            activeIds: [
              ...new Set([
                ...activeIds,
                ...res.data.map(({ course_id }) => course_id),
              ]),
            ],
            userComment: res.data[0].user_comment,
          });
        this.setState({
          activeIds: res.data.map(({ course_id }) => course_id),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  updateUser = () => {
    const { dutyLocationValue } = this.state;

    const data = {
      post_id: dutyLocationValue.id,
    };

    this.props
      .dispatch(
        userActions.API("put", `v1/user/edit_profile`, data, true, false)
      )
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  tempUserUpdate = () => {
    const { jobGroupValue } = this.state;

    const doesHavePost = JSON.parse(
      localStorage.getItem("globalStorage")
    ).value.hasOwnProperty("post");

    if (!doesHavePost) {
      return this.getTitles();
    }

    const postArr = JSON.parse(localStorage.getItem("globalStorage")).value
      .post;

    if (postArr.length === 0) {
      return this.getTitles();
    }

    const { name, job_location } = JSON.parse(
      localStorage.getItem("globalStorage")
    ).value.post[0];

    const data = {
      post: {
        name,
        job_group: jobGroupValue.name,
        job_location,
      },
    };

    this.props
      .dispatch(
        userActions.API("put", `v1/user/edit_profile`, data, true, false)
      )
      .then(() => {
        localStorage.setItem("temp_job_group", jobGroupValue.name);
        this.getTitles();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handlePost = (save) => {
    const { goBack } = this;
    const { userComment, titles } = this.state;
    const TitleIds = titles.map(({ id }) => id);
    const allIds = [
      ...this.state.activeIds,
      ...this.state.titles
        .filter((title) => title.course_type === "2")
        .map((title) => title.id),
    ].filter((id) => TitleIds.includes(id));
    const data = {
      save,
      courses: [...new Set(allIds)].map((id) => {
        return { id, comment: userComment };
      }),
    };

    this.props
      .dispatch(
        userActions.API(
          "post",
          `v1/user/hospital/course/request`,
          data,
          true,
          false
        )
      )
      .then(() => {
        this.setState({
          jobGroupValue: null,
          dutyLocationValue: null,
          titles: [],
          finalPostModal: false,
        });
        goBack();
        userActions.successToast(
          save
            ? "ثبت نهایی با موفقیت انجام شد."
            : "ثبت موقت با موفقیت انجام شد."
        );
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getMe = () => {
    this.props
      .dispatch(userActions.API("get", `v1/user/me`, null, true, false))
      .then((res) => {
        this.setState({ post: res.data.post[0] });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleCancel = () => {
    this.props
      .dispatch(userActions.question("انصراف", "آیا از انصراف مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          this.goBack();
        }
      });
  };

  handleWarnBeforePost = () => {
    this.props
      .dispatch(
        userActions.warningWithSubmitAndCancel(
          "متوجه شدم",
          "بعد از ثبت نهایی به هیچ عنوان امکان تغییر و ویرایش وجود ندارد."
        )
      )
      .then((r) => {
        if (r.value) {
          this.handlePost(true);
          this.setState({
            jobGroupValue: null,
            dutyLocationValue: null,
            titles: [],
            finalPostModal: false,
          });
        }
      });
  };

  checkBeforePost = () => {
    this.state.activeIds.length === 0
      ? userActions.failure("لطفاً یک نیازسنجی را انتخاب نمایید.")
      : this.handlePost(false);
  };

  checkBeforeFinalPost = () => {
    this.state.activeIds.length === 0
      ? userActions.failure("لطفاً یک نیازسنجی را انتخاب نمایید.")
      : this.handleWarnBeforePost();
  };

  render() {
    const {
      handleCancel,
      handlePost,
      handleWarnBeforePost,
      updateUser,
      tempUserUpdate,
    } = this;
    const {
      jobGroupOptions,
      jobGroupValue,
      dutyLocationValue,
      dutyLocationOptions,
      titles,
      finalPostModal,
      activeIds,
      userComment,
    } = this.state;

    const text1 = "پس از تایید امکان ویرایش ندارید!";
    const text2 =
      "آیا از ارسال نیازسنجی های آموزشی انتخابی به مافوق خود اطمینان دارید؟";

    return (
      <div className="requestEdu bg-light bg-drr pt-3 pb-5 px-3">
        <Routes page="pdp/requestEdu" />
        <div className="container-fluid adminMessage">
          <div className="card bg-white shadow text-center border-0">
            <AdminMessage text="توجه داشته باشید پس از ارسال نیازسنجی های درخواستی امکان تغییر وجود نخوهد داشت" />
          </div>
        </div>
        <br />
        <NotifCard
          text1="کاربر گرامی لطفاً متناسب با گروه شغلی، نیازسنجی های درخواستی مورد نیاز خود را
        انتخاب نمایید. توجه داشته باشید شما تنها مجاز به انتخاب نیازسنجی های یک گروه
        شغلی می باشید."
        />
        <br />
        <div className="container-fluid px-5 pb-5 selectParent">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-4 rowParent">
              <div className=" w-100 d-inline-block px-4">
                {/* <p></p> // title select type */}
                <SelectType
                  value={jobGroupValue}
                  options={jobGroupOptions}
                  onChange={(e) => {
                    this.setState({ jobGroupValue: e }, tempUserUpdate);
                  }}
                  placeholder="گروه شغلی خود را انتخاب کنید"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid listContainer px-5 pb-5">
          <div className="row">
            <div className="col-lg-9 col-md-12 listContainer2 m-auto">
              <List
                jobGroupValue={jobGroupValue}
                userComment={userComment}
                onCancel={handleCancel}
                onPost={() => {
                  activeIds.length === 0
                    ? userActions.failure("لطفاً یک نیازسنجی را انتخاب نمایید.")
                    : handlePost(false);
                }}
                onPostFinal={() => {
                  activeIds.length === 0
                    ? userActions.failure("لطفاً یک نیازسنجی را انتخاب نمایید.")
                    : this.setState({
                        finalPostModal: true,
                      });
                }}
                onUserComment={(e) =>
                  this.setState({ userComment: e.target.value })
                }
              >
                {titles.length ? (
                  Array.from({ length: titles.length }).map((_, i) => (
                    <ListItem
                      i={i}
                      key={i + 1}
                      activeIds={activeIds}
                      data={titles[i]}
                      onAdd={(ids) => this.setState({ activeIds: ids })}
                    />
                  ))
                ) : (
                  <EmptyListItem />
                )}
              </List>
            </div>
          </div>
        </div>
        <Modal
          isOpen={finalPostModal}
          contentLabel="add Modal"
          portalClassName="full_screen_modal"
          className="requestEdu"
        >
          <ModalAddDutyLoc
            onClose={() =>
              this.setState({
                dutyLocationValue: null,
                finalPostModal: false,
              })
            }
            onPost={() => {
              if (dutyLocationValue === null) {
                userActions.failure("لطفاً محل خدمت را انتخاب نمایید.");
              } else {
                handleWarnBeforePost();
              }
            }}
          >
            <NotifCard text1={text1} text2={text2} color1="red" />
            <div className="mb-5 w-100 px-4 d-inline-block mt-2 container_reqedu">
              <p className="px-3 w-100 text-right text_style">
                مافوق شما مسئول کدام واحد می باشد؟
              </p>
              <SelectType
                value={dutyLocationValue}
                options={dutyLocationOptions}
                onChange={(e) => {
                  this.setState({ dutyLocationValue: e }, updateUser);
                }}
                placeholder="محل خدمت مافوق خود را انتخاب کنید"
              />
            </div>
          </ModalAddDutyLoc>
        </Modal>
      </div>
    );
  }
}

class ModalAddDutyLoc extends Component {
  render() {
    const { onPost, onClose, children } = this.props;

    return (
      <div className="modal--add-duty-location">
        <div className="row col-lg-12 col-md-12 banner">
          <p>تعیین مافوق</p>
          <button onClick={onClose}>&#10005;</button>
        </div>
        {children}
        <div className="row col-lg-12 footer">
          <button onClick={onPost}>ثبت</button>
          <button onClick={onClose}>انصراف</button>
        </div>
      </div>
    );
  }
}

class EmptyListItem extends Component {
  render() {
    return (
      <li className="requestEdu__list__item empty-list">
        <p className="requestEdu__list__item__text empty-list__child">
          برای نمایش نیازسنجی ها گروه شغلی خود را از دکمه بالا انتخاب نمایید
        </p>
      </li>
    );
  }
}

class SelectType extends Component {
  render() {
    const { value, onChange, options, placeholder, isMulti } = this.props;
    const selectStyle = {
      container: (baseStyles) => ({
        ...baseStyles,
        height: "50px",
      }),
      control: (baseStyles) => ({
        ...baseStyles,
        padding: "6px 10px 6px 5px",
        height: "100%",
        color: "#104c81",
        border: "1px solid #104c81",
        borderRadius: "50px",
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        zIndex: "999",
        textAlign: "right",
      }),
    };

    const multiSelectStyle = {
      control: (baseStyles) => ({
        ...baseStyles,
        padding: "6px 10px 6px 5px",
        boxShadow: "0px 0px 4px 1px #ccc",
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        zIndex: "999",
        textAlign: "right",
      }),
    };

    return (
      <>
        {isMulti ? (
          <Select
            isMulti
            styles={multiSelectStyle}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
          />
        ) : (
          <Select
            styles={selectStyle}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
          />
        )}
      </>
    );
  }
}

class NotifCard extends Component {
  render() {
    const { text1, text2, color1 = "#777777", color2 = "#6c00ff" } = this.props;

    return (
      <div className="notif py-3 px-5">
        <p style={{ color: color1, margin: 0 }}>{text1}</p>
        {text2 && (
          <p style={{ color: color2, margin: "10px 0 0 0" }}>{text2}</p>
        )}
      </div>
    );
  }
}

class List extends Component {
  render() {
    const {
      onCancel,
      onPostFinal,
      onPost,
      userComment,
      jobGroupValue,
      onUserComment,
    } = this.props;

    return (
      <div
        className="list-wrapper"
        style={{
          padding:
            jobGroupValue !== null
              ? "20px 20px 300px 20px"
              : "20px 20px 90px 20px",
        }}
      >
        <ul className="requestEdu__list">
          <Banner />
          {this.props.children}
        </ul>
        {jobGroupValue !== null ? (
          <div className="boldMobile commentArea boldMobile commentArea  w-100 mt-4 px-4 mb-1 container_txtarea">
            <p className="text-right w-100 px-3 text_style">
              در صورتی که نیاز آموزشی دیگری دارید، آن را پیشنهاد دهید.
            </p>
            <Textarea
              placeholder="نیاز آموزشی خود را بنویسید..."
              value={userComment}
              onChange={onUserComment}
            />
          </div>
        ) : (
          ""
        )}
        <div className="btn-container d-flex justify-content-center align-items-center edu_container">
          <button
            className=" btn btn-primary mx-1 rounded-pill button_edu "
            onClick={onPostFinal}
          >
            <p className="m-0 py-2">ثبت نهایی و ارسال به مافوق</p>
          </button>
          <button
            className="btn mx-1 rounded-pill button_edu_empty"
            onClick={onPost}
          >
            <p className="m-0 py-2">ثبت موقت</p>
          </button>
          <button
            className="btn mx-1 rounded-pill button_edu_empty"
            onClick={onCancel}
          >
            <p className="m-0 py-2">بازگشت</p>
          </button>
        </div>
      </div>
    );
  }
}

class Banner extends Component {
  render() {
    return (
      <li className="requestEdu__list__banner" key="0">
        <div className="requestEdu__list__banner__child">ردیف</div>
        <div className="requestEdu__list__banner__child">عنوان نیازسنجی</div>
        <div className="requestEdu__list__banner__child">وضعیت</div>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    const { i, data, activeIds, onAdd } = this.props;
    const { id, title, course_type } = data;
    const haveThisId = activeIds.some((_id) => _id === id);

    return (
      <li
        className={`requestEdu__list__item`}
        onClick={() => {
          course_type !== "2" &&
            onAdd(
              haveThisId
                ? activeIds.filter((_id) => _id !== id)
                : [...activeIds, id]
            );
        }}
      >
        <ListItemBtnContainer>
          <p className="requestEdu__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="requestEdu__list__item__text" data-tip={title}>
            {title}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound
            data_tip={`${
              course_type === "2"
                ? "انتخاب شده توسط سازمان (الزامی)"
                : haveThisId
                ? "انتخاب شده"
                : "انتخاب نشده"
            }`}
            className={`${
              course_type === "2"
                ? "success-dark"
                : haveThisId
                ? "success"
                : "empty"
            }-icon`}
          />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <button
        className={`btn-round ${this.props.className}`}
        onClick={this.props.onClick}
        data-tip={this.props.data_tip}
      ></button>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="requestEdu__list__item__btn-container">
        {this.props.children}
        {/* <ReactTooltip type="dark" /> */}
      </div>
    );
  }
}

class Textarea extends Component {
  render() {
    return (
      <textarea
        className={`special-textarea ${this.props.className}`}
        placeholder={`${this.props.placeholder || ""}`}
        value={this.props.value || ""}
        onChange={this.props.onChange}
      />
    );
  }
}

const RequestEdu = connect((state) => ({
  globalStorage: state.globalStorage,
}))(RequestEdu_);
export { RequestEdu };
